import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/pages/Index';
import Imprint from '@/components/pages/Imprint';
import PrivacyPolicy from '@/components/pages/PrivacyPolicy';
import TermsOfService from '@/components/pages/TermsOfService';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/imprint',
      name: 'Imprint',
      component: Imprint,
    },
    {
      path: '/tos',
      name: 'TermsOfService',
      component: TermsOfService,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
  ],
});




// WEBPACK FOOTER //
// ./src/router/index.js